import tbIntegerValidation from './tb-integer-validation.directive';

export  default angular
    .module('tb.integer-validation', [])
    .directive('tbIntegerValidation', tbIntegerValidation)
    .name;